export default "__VITE_ASSET__5f067ca4__"